import { apiClient } from './axios';

import type {
  PaginatedResponse,
  ScheduledMessageQuery,
  ScheduledMessageWithRelations,
} from '@repo/shared-types';

export const scheduledMessagesApi = {
  getAll: async (query: Partial<ScheduledMessageQuery> = {}) => {
    const response = await apiClient.get<PaginatedResponse<ScheduledMessageWithRelations>>(
      '/scheduled-messages',
      { params: query },
    );
    return response.data;
  },

  getOne: async (id: string) => {
    const response = await apiClient.get<ScheduledMessageWithRelations>(
      `/scheduled-messages/${id}`,
    );
    return response.data;
  },

  cancel: async (id: string) => {
    const response = await apiClient.post<{ cancelled: boolean }>(
      `/scheduled-messages/${id}/cancel`,
    );
    return response.data;
  },
};
